import { Box, CircularProgress } from "@mui/material";

const Spinner = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
    }}
  >
    <CircularProgress />
  </Box>
  //   <div style={{ textAlign: "center", padding: "20px" }}>
  //     <div className="spinner" />
  //     <style jsx>{`
  //       .spinner {
  //         border: 4px solid rgba(0, 0, 0, 0.1);
  //         width: 36px;
  //         height: 36px;
  //         border-radius: 50%;
  //         border-left-color: #09f;
  //         animation: spin 1s linear infinite;
  //       }
  //       @keyframes spin {
  //         to {
  //           transform: rotate(360deg);
  //         }
  //       }
  //     `}</style>
  //   </div>
);

export default Spinner;
